export default {
  setUsers: (state, users) => {
    state.users = users
  },
  setCompany: (state, company) => {
    state.company = company
  },
}
